<template>
  <div class="my_edit">
    <CellGroup>
      <Cell title="头像" center>
        <img :src="userInfo.avatarurl" alt class="avatar" />
      </Cell>
      <Cell title="昵称" :value="userInfo.nickname"></Cell>
      <Cell
        title="姓名"
        :value="userInfo.name"
        input-align="right"
        is-link
        @click="showPopup('name')"
      ></Cell>
      <Cell
        title="手机号"
        :value="userInfo.phone"
        input-align="right"
        placeholder="请输入手机号码"
        type="number"
        is-link
        @click="showPopup('phone')"
      ></Cell>
      <Cell
        title="身份证号码"
        :value="userInfo.id_number"
        input-align="right"
        placeholder="请输入身份证号码"
        is-link
        @click="showPopup('id_number')"
      ></Cell>
      <Cell
        title="地址"
        :value="userInfo.address"
        input-align="right"
        is-link
        @click="showPopup('address')"
      ></Cell>
    </CellGroup>

    <Popup v-model="show" closeable position="right" :style="{ height: '100%',width:'100%' }">
      <CellGroup title="信息修改" :border="false">
        <Field autofocus v-if="fieldShow.name" label="姓名" v-model="userInfo.name"></Field>
        <Field
          autofocus
          label="手机号"
          v-if="fieldShow.phone"
          v-model="userInfo.phone"
          placeholder="请输入手机号码"
          type="tel"
        ></Field>
        <Field
          autofocus
          label="身份证号码"
          v-if="fieldShow.id_number"
          v-model="userInfo.id_number"
          placeholder="请输入身份证号码"
        ></Field>
        <Field
          autofocus
          placeholder="请输入地址"
          label="地址"
          v-if="fieldShow.address"
          v-model="userInfo.address"
        ></Field>
        <van-button
          style="display:block;margin:10px auto;width:80vw;"
          type="info"
          round
          block
          @click="editUserInfo"
        >提交</van-button>
      </CellGroup>
    </Popup>
  </div>
</template>
<style lang="less" scoped>
@import url("./index.less");
</style>
<script>
import { Cell, CellGroup, Field, Popup } from "vant";
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      storeuserInfo: (state) => state.user.userInfo,
    }),
  },
  data() {
    return {
      userInfo: "",
      show: false,
      fieldShow: {},
    };
  },
  components: {
    Cell,
    CellGroup,
    Field,
    Popup,
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    editUserInfo() {
      if (this.selectField == "id_number") {
        this.$dialog
          .confirm({
            title: "提示",
            message: "身份证号码提交后不可修改。确定提交?",
          })
          .then(() => {
            this.$api.user
              .editUserInfo({
                [this.selectField]: this.userInfo[this.selectField],
              })
              .then((res) => {
                if (res.status === 200) {
                  this.show = false;
                  this.$toast.success("操作成功");
                  this.getUserInfo(true);
                }
              });
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$api.user
          .editUserInfo({ [this.selectField]: this.userInfo[this.selectField] })
          .then((res) => {
            if (res.status === 200) {
              this.show = false;
              this.$toast.success("操作成功");
              this.getUserInfo(true);
            }
          });
      }
    },
    getUserInfo(update) {
      this.$toast.loading("加载中...");
      this.$api.user.getUserInfo().then((res) => {
        if (res.status * 1 === 200) {
          this.userInfo = res.data;
          if (update) {
            this.storeuserInfo.userInfo = res.data;
            this.setUserInfo(this.storeuserInfo);
          }
        }
        setTimeout(() => {
          this.$toast.clear();
        }, 500);
      });
    },
    showPopup(field) {
      if (field === "id_number" && !!this.userInfo[field]) {
        this.$toast("身份证号码暂时不支持修改");
        return;
      }
      this.show = true;
      this.fieldShow = Object.assign({}, { [field]: true });
      this.selectField = field;
    },
  },
  mounted() {
    this.getUserInfo();
  },
};
</script>
